/**
 * @generated SignedSource<<13e644465664230f388701335c141b95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SurveyInvitations_notificationSubscriptions$data = {
  readonly id: string;
  readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  readonly " $fragmentType": "SurveyInvitations_notificationSubscriptions";
};
export type SurveyInvitations_notificationSubscriptions$key = {
  readonly " $data"?: SurveyInvitations_notificationSubscriptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"SurveyInvitations_notificationSubscriptions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SurveyInvitations_notificationSubscriptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyInviteContactChannels",
      "storageKey": null
    }
  ],
  "type": "NotificationSubscriptions",
  "abstractKey": null
};

(node as any).hash = "917ca397b6e04dc97f8653c7236e454d";

export default node;
